import React from "react";
import CardProfile from "src/components/molecules/Profile";
import BalanceCard from "src/components/molecules/BalanceCard";

const Right = () => {
  return (
    <div className="px-8 pt-5 pb-8 xl:pb-0 h-full xl:h-screen bg-blues-cool">
      <div className="flex-shrink-0 ml-51.01 mb-10">
        <CardProfile />
      </div>
      <div>
        <BalanceCard />
      </div>
    </div>
  );
};

export default Right;
